<template>
    <div>
        <transition name="fade" mode="out-in">
            <PasoBuscarAbonado
                v-if="paso0"
                :event="event"
                :sesion_id="parseInt(sesion_id)"
                @setSeccionDisponible="(event) => seccion_disponible = event"
                @setDatos="datos_compradores = $event"
                @setAsientos="asientos = $event"
                @setPlaza="plaza = $event"
                @seleccionarNuenoAsiento="seleccionarNuenoAsiento"
                @bloquearAsientos="bloquearAsientos"
                @bloquearPlaza="bloquearPlaza"
                @setZona="zona = $event"
                :disabled="isDisabled"
            />
        </transition>
        <transition name="fade" mode="out-in">
            <section class="padding-vertical-content" v-if="paso1" key="paso1" id="paso1">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <h2 class="m-0 h1 text-uppercase">{{ $t('partido.selecciona_entradas', { entradas: "entradas" }) }}</h2>
                        </div>

                        <div class="col-12">
                            <transition name="fade" mode="out-in">
                                <div class="row" v-if="zonas" key="zonas" id="zonas">
                                    <div class="col-lg-8">
                                        <h3 class="subtitle h3 light mb-3 ">A) {{ $t('partido.pinchando_mapa') }}:</h3>
                                        <div class="lightgray-content">
                                            <div>
                                                <SvgComponent
                                                    :zonas="zonas_formated"
                                                    :place="event.place"
                                                    :sesion_id="sesion_id"
                                                    @clickZona="finalizarPasoUno"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-lg-4">
                                        <h3 class="subtitle h3 light mb-3 ">B) {{ $t('partido.tabla') }}:</h3>
                                        <div class="lightgray-content p-2 pb-0">
                                            <TablaSectoresComponent :zonas="zonas" v-on:goTo="finalizarPasoUno"/>
                                        </div>
                                    </div>
                                </div>
                                <div class="row" v-else>
                                    <div class="col-12 text-center" style="height: 400px">
                                        <LoaderComponent/>
                                    </div>
                                </div>
                            </transition>
                        </div>
                    </div>
                </div>
            </section>
        </transition>
        <VisibilidadReducida :zona="zona" @aceptar="AceptarVisibilidadReducida"/>
        <transition name="fade" mode="out-in">
            <section class="padding-vertical-content" v-if="paso2" key="paso2" id="paso2">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <h2 class="m-0 h1 text-uppercase">{{ $t('partido.elige_asientos') }}</h2>
                            <h3 class="subtitle h3 light mb-3 ">{{ $t('partido.varios_asientos') }}</h3>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 col-lg-4">
                            <div class="oswald text-uppercase">{{ $t('partido.zona_seleccionada') }}:</div>
                            <span class="h2 mb-1 d-block">{{ zona.name }} <button class="h6 button small-button m-0" @click="volver" :disabled="paso3"><i class="fa fa-redo"></i> {{ $t('partido.cambiar_zona') }}</button></span>

                            <div v-if="zona.imagen" class="mb-3">
                                <img :src="zona.imagen"/>
                            </div>
                            <div v-if="asientos_maximos > 1" class="alert alert-primary mb-3" role="alert">
                                <b>{{ $t('partido.add_acompanantes') }}</b>
                            </div>
                            <SelectorZonaComponent :zona="zona" :zonas="zonas"/>
                            <TusAsientosComponent
                                :precios="zona.precios_abonados"
                                :precios_acompanante="zona.precios_acompanante"
                                :asientos="asientos"
                                :event="event"
                                v-on:continuar="bloquearAsientos"
                                :puedo_cambiar="paso3 ? false : true"
                                :puedo_continuar="!paso3"
                                :loading="loading"
                            />
                        </div>
                        <div class="col-12 col-lg-8 order-first order-lg-last">
                            <div v-if="zona.with_seats">
                                <AsientosComponent 
                                    :zona="zona" 
                                    :asientos="asientos" 
                                    :asientos_maximos="asientos_maximos"
                                    :abonadoId="datos_compradores.id"
                                    :puedo_cambiar="paso3 ? false : true"
                                />
                            </div>
                            <div v-else>
                                <p class="oswald text-uppercase mt-lg-4">{{ $t('partido.numero_entradas', {entradas: "entradas"}) }}</p>
                                <div class="form-group">
                                    <multiselect
                                        v-model="n_entradas"
                                        :placeholder="$t('partido.numero_entradas', {entradas: 'entradas'})"
                                        :show-labels="false"
                                        :options="options"
                                        :allow-empty="false"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </transition>

        <transition name="fade" mode="out-in">
            <section class="padding-vertical-content lightgray-content" v-if="paso3" key="paso3" id="paso3">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <DatosCompradoresComponent 
                                :datos_compradores="datos_compradores" 
                                :generos="generos" 
                                :solicitar_datos="event.solicitar_datos" 
                                :asientos="asientos" 
                                @terminar="guardarDatos" 
                                :loading="loading" 
                                :fields="event.fields"
                                :reserva_instalaciones="event.reserva_instalaciones"
                                :errors="errors"
                                :plazas="plaza ? [plaza] : null"
                                @cambiar-asiento="cambiarAsiento"
                            />
                        </div>
                    </div>
                </div>
            </section>
        </transition>

        <transition name="fade" mode="out-in">
            <section class="padding-vertical-content" v-if="resumen" key="resumen" id="resumen">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <h2 class="m-0 h1 text-uppercase">{{ $t('partido.resumen_compra') }}</h2>
                            <div class="subtitle h3 light mb-3 mb-lg-5">{{ $t('partido.revisa_datos') }}</div>
                            <ResumenCompraComponent
                                :entradas="asientos"
                                :formulario="formulario"
                                :datos="datos_compradores"
                                :event="event"
                                :session_id="session_id"
                                @terminado="procesarPago"
                                :entradasPlazas="plaza ? [plaza] : null"
                                @volver="volver"
                                :voucher="voucher"
                            />
                        </div>
                    </div>
                </div>
            </section>
        </transition>

        <transition name="fade" mode="out-in">
            <section class="padding-vertical-content lightgray-content" v-if="procesar_pago" key="pago" id="pago">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <h2 class="m-0 h1 text-uppercase">{{ $t('compra.confirmacion_compra') }}</h2>
                            <div class="subtitle h3 light mb-3 mb-lg-5">{{ $t('compra.introduce_datos') }}</div>
                            <PagoPaycometComponent
                                ref="pago"
                                tipo_venta="evento"
                                :jet_id="jet_id"
                                :session_id="session_id"
                            />		
                        </div>
                    </div>
                </div>
            </section>
        </transition>
    </div>
</template>

<script>
    import SvgComponent from '@/components/svg/SvgComponent';
    import TablaSectoresComponent from '@/components/frontend/events/compra/TablaSectoresComponent';
    import AsientosComponent from '@/components/frontend/events/compra/AsientosComponent';
    import SelectorZonaComponent from '@/components/frontend/events/compra/SelectorZonaComponent';
    import TusAsientosComponent from '@/components/frontend/events/compra/TusAsientosComponent';
    import DatosCompradoresComponent from '@/components/frontend/events/compra/DatosCompradoresComponent';
    import ResumenCompraComponent from '@/components/frontend/events/compra/ResumenCompraComponent';
    import Generos from "@/mixins/Generos";
    import PagoPaycometComponent from '@/components/frontend/compra/components/PagoPaycometComponent.vue';
    import VisibilidadReducida from '@/components/frontend/components/modals/VisibilidadReducida.vue';
    import PasoBuscarAbonado from './Pasos/PasoBuscarAbonado.vue';

    export default {
        props: ['event', 'sesion_id', 'tiempoTerminado'],
        mixins: [Generos],
        data() {
            return {
                zonas: null,
                zona: null,
                asientos: [],
                paso0: true,
                paso1: false,
                paso2: false,
                paso3: false,
                resumen: false,
                loading: false,
                session_id: null,
                datos_compradores: {},
                formulario: null,
                n_entradas: 0,
                abonado: null,
                asientos_maximos: 1,
                seccion_disponible: null,
                procesar_pago: false,
                jet_id: null,
                errors: null,
                plaza: null,
                voucher: null,
            }
        },
        created() {
            if (this.configuracion.hash_teatro !== 'K2CEa3vYJOmQJS1gTuxu') {
                this.asientos_maximos = this.asientos_maximos + this.event.n_acompanantes;
            }

            this.getGeneros();
            setTimeout(() => {
                this.$nextTick(() => {
                    this.scrollTo('#paso0', 1000);
                })
            }, 500)        
        },
        beforeDestroy() {
            if (this.procesar_pago) {
                this.$refs.pago.clearAllIntervals();
            }
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            mostrar_header() {
                if(this.$route.name == 'front.home') {
                    return false;
                }
                if(this.$route.name == 'login') {
                    return false;
                }

                return true;
            },
            user() {
                return this.$store.getters.getUser;
            },
            entradas_disponibles() {
                return this.zona.aforo - this.zona.confirmados - this.zona.no_confirmados;
            },
            options() {
                var tope = this.asientos_maximos;

                if(this.entradas_disponibles < tope) {
                    tope = this.entradas_disponibles;
                }

                var opciones = [];

                for(var i = 1; i <= tope; i++) {
                    opciones.push(i);
                }

                return opciones;
            },
            zonas_formated() {
                var array = [];
                for(var zona in this.zonas) {
                    array.push(this.zonas[zona]);
                    var precios_array = [];

                    for(var pa in array[zona].precios_abonados) {
                        precios_array.push({
                            'descripcion': array[zona].precios_abonados[pa].descripcion,
                            'gd': array[zona].precios_abonados[pa].gd,
                            'gd_interno': array[zona].precios_abonados[pa].gd_interno,
                            'id': array[zona].precios_abonados[pa].id,
                            'precio': array[zona].precios_abonados[pa].precio,
                            'precio_total': array[zona].precios_abonados[pa].precio + array[zona].precios_abonados[pa].gd
                        })
                    }

                    array[zona].precios = precios_array;
                    var disponible = precios_array.length > 0 && array[zona].esta_disponible ? true : false;
                    array[zona].esta_disponible = disponible;
                    if(this.seccion_disponible != array[zona].seccion && this.event.seccion == 1) {
                        array[zona].esta_disponible = false;
                    }
                }

                return array;
            },
            footer() {
                return this.$store.getters.getFooter;
            },
            isDisabled() {
                return this.paso3 || this.loading || this.paso1 || this.paso2;
            }
        },
        watch: {
            n_entradas() {
                var datos = [];
                for (var i = 0; i < this.n_entradas; i++) {
                    datos.push({
                        'apellidos': '',
                        'asiento': {
                            'zona_id': this.zona.id,
                            'asiento': 0,
                            'fila': 0,
                            'zona_nombre': this.zona.name
                        },
                        'dni': '',
                        'es_nuevo': true,
                        'nombre': '',
                        'precio': null,
                        'precios': this.zona.precios,
                        'telefono': '',
                        'url_imprimir': ''
                    });
                }

                this.asientos = datos;
            },
            tiempoTerminado(tiempoTerminado) {
                if (tiempoTerminado) {
                    this.recargar();
                }
            },
            zona() {
                if(this.configuracion.hash_teatro === 'K2CEa3vYJOmQJS1gTuxu' && this.zona && Array.isArray(this.zona.precios_acompanante) && this.zona.precios_acompanante.length > 0) {
                    this.asientos_maximos = this.asientos_maximos + this.event.n_acompanantes;
                }
            }
        },
        methods: {
            cambiarAsiento() {
                this.borrarSesion(this.session_id);
                this.paso1 = true;
                this.paso2 = false;
                this.paso3 = false;
                this.resumen = null;
                this.asientos = [];
                this.datos_compradores = {};
                setTimeout(() => {
                    this.$nextTick(() => {
                        this.scrollTo('#paso1', 1000);
                    })
                }, 500)
                this.getZonas();
            },
            procesarPago() {
                this.procesar_pago = true;
                this.$nextTick(() => {
                    this.scrollTo('#pago')
                })
            },
            seleccionarNuenoAsiento() {
                this.getZonas();
                this.asientos = [];
                this.paso1 = true;
                this.$nextTick(() => {
                    this.scrollTo('#paso1', 1000);
                })
            },
            getZonas() {
                this.loading = true;

                const params = {
                    filters: {
                        sesion_id: this.sesion_id,
                        abonado_id: this.datos_compradores.id
                    },
                }

                this.$store.dispatch(this.config.getVuexAlias('front.zonas.index'), params).then(res => {
                    this.zonas = res.data.data;
                }).finally(() => this.loading = false);
            },
            volver() {
                this.paso1 = true;
                this.paso2 = false;
                this.paso3 = true;
                this.resumen=null;
            },
            finalizarPasoUno(zona) {
                this.zona = zona;
                if(zona.visibilidad_reducida){
                    this.$modal.show('visibilidad-reducida');
                }
                this.paso1 = false;
                this.paso2 = true;
            },
            bloquearAsientos() {
                this.loading = true;

                let seats = [];

                for(var i in this.asientos) {
                    if(i == 0) {
                        this.asientos[i].nombre = this.datos_compradores.nombre;
                        this.asientos[i].apellidos = this.datos_compradores.apellidos;
                    }
                    seats.push(this.asientos[i].asiento);
                }

                let params = {
                    filters: {
                        sesion_id: this.sesion_id,
                        tid: this.configuracion.hash_teatro
                    },
                    zona_id: this.zona.id,
                    asientos: seats,
                    datos_abonado: this.datos_compradores,
                    tid: this.configuracion.hash_teatro
                }

                const cookie = this.$cookies.get('comunicados-track-id');

                if(cookie) {
                    params.token_comunicado = cookie;
                }

                this.$store.dispatch(this.config.getVuexAlias('front.bloquear.asientos'), params).then(res => {
                    this.session_id = res.data.session_id;
                    this.paso3 = true;
                    this.$nextTick(function() {
                        this.scrollTo('#paso3');
                    });
                }).finally(() => this.loading = false);
            },
            bloquearPlaza() {
                this.loading = true;

                const data = [{
                    'butaca_id': this.plaza.id,
                    'precio_id': this.plaza.precio_id
                }];

                const params = {
                    filters: {},
                    event_id: this.event.id,
                    sesion_id: this.sesion_id,
                    datos_abonado: this.datos_compradores,
                    data: data,
                    region_id: this.plaza.region_id
                };

                this.$store.dispatch(this.config.getVuexAlias('front.evento.sesion.bloquear-butacas'), params).then(res => {
                    this.session_id = res.data.session_id;
                    this.paso3 = true;
                    this.$nextTick(function() {
                        this.scrollTo('#paso3');
                    });
                }).catch(error => {
                    if (error?.response?.data?.message) {
                        this.$toast.error('Butaca/s ocupada/s');
                    }
                }).finally(() => {
                    this.loading = false;
                });
            },
            guardarDatos(info_entradas) {
                this.loading = true;

                this.datos_compradores.asientos = this.asientos;

                const params = {
                    filters: {
                        sesion_id: this.sesion_id,
                        tid: this.configuracion.hash_teatro
                    },
                    datos_compradores: this.datos_compradores,
                    session_id: this.session_id,
                    tid: this.configuracion.hash_teatro
                }

                this.$store.dispatch(this.config.getVuexAlias('front.guardar.datos.comprador'), params).then(res => {
                    if (Array.isArray(res.data.datos_compradores) && res.data.datos_compradores.length > 0 && res.data.datos_compradores[0]['voucher']) {
                        this.voucher = res.data.datos_compradores[0]['voucher'];
                    }
                    this.jet_id = res.data.jet_id;
                    this.formulario = res.data.formulario;
                    this.resumen = true;
                    this.$nextTick(function() {
                        this.scrollTo('#resumen');
                    });
                }).catch(error => {
                    if (error.response.data.message == 'Campos requeridos') {
                        this.errors = error.response.data.errors;
                    } else {
                        this.$toast.error(error.response?.data?.message);
                    }
                }).finally(() => this.loading = false);
            },
            scrollTo(paso, duracion = 1000) {
                this.$scrollTo(paso, duracion)
            },
            borrarSesion(session_id) {
                const params = {
                    filters: {
                        session_id: session_id,
                        tid: this.configuracion.hash_teatro
                    },
                    session_id: session_id,
                    tid: this.configuracion.hash_teatro
                }

                this.$store.dispatch(this.config.getVuexAlias('front.sesion.delete'), params).then(res => {
                })
            },
            recargar() {
                if (this.procesar_pago) {
                    this.$refs.pago.clearAllIntervals();
                }
                this.$emit('reset')
            },
            AceptarVisibilidadReducida(){
                this.$modal.hide('visibilidad-reducida');
            }
        },
        components: {
            TablaSectoresComponent, AsientosComponent,
            SelectorZonaComponent, TusAsientosComponent, DatosCompradoresComponent,
            ResumenCompraComponent, SvgComponent, PagoPaycometComponent,
            VisibilidadReducida, PasoBuscarAbonado
        }
    }
</script>

<style>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .2s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
    
    @media (max-width: 768px) {
        .text-justify-sm {
            text-align: justify;
        }
        .text-center-sm {
            text-align: center;
        }
    }
</style>
